import { render } from "./RuleAdd.vue?vue&type=template&id=09acdaf3&scoped=true"
import script from "./RuleAdd.vue?vue&type=script&lang=js"
export * from "./RuleAdd.vue?vue&type=script&lang=js"

import "./RuleAdd.vue?vue&type=style&index=0&id=09acdaf3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09acdaf3"]])

export default __exports__